import { render, staticRenderFns } from "./ModalAguardandoCotacao.vue?vue&type=template&id=6bd8eb09&scoped=true"
import script from "./ModalAguardandoCotacao.vue?vue&type=script&lang=ts"
export * from "./ModalAguardandoCotacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalAguardandoCotacao.vue?vue&type=style&index=0&id=6bd8eb09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd8eb09",
  null
  
)

export default component.exports